<template>
  <v-card class="elevation-10 document-card mb-6">
    <div class="specific-people-info-container">
      <h2 class="people-headings mb-0">
        {{ category.displayName }}
      </h2>
      <DocumentBadges :category="category" />
      <p class="card-description">{{ category.description }}</p>

      <div v-if="documents.length" class="documents mt-4">
        <div v-for="doc in documents" :key="doc.id" class="document-instance">
          <DocumentFileRow
            v-for="file in doc.files"
            :key="file.id"
            :file="file"
            :read-only="!canDeleteDocuments"
            @file-deleted="$emit('refetch')"
          />
          <p v-if="doc.notes" class="document-note-row">
            <strong>Note:</strong> {{ doc.notes }}
          </p>
          <div class="card-button-container no-border">
            <FunkButton
              :button-text="doc.notes ? 'Edit note' : 'Add note'"
              @buttonClicked="openEdit(doc)"
            />
          </div>
        </div>
      </div>

      <div
        v-if="!documents.length"
        class="dropzone d-flex align-center mt-4"
        data-test="open-upload"
        @click="showUpload = true"
      >
        <DocumentIconBadge icon="upload" tile class="mr-3" />
        <div class="flex-grow-1">
          <div class="dropzone-title">Click to upload</div>
          <div class="dropzone-hint">PDF, JPG or PNG · Up to 30 MB</div>
        </div>
        <DocumentUploadButton @click="showUpload = true" />
      </div>

      <div v-if="documents.length" class="card-cta-row">
        <DocumentUploadButton
          label="Upload another"
          @click="showUpload = true"
        />
      </div>

      <UploadDocumentDialog
        v-if="showUpload"
        v-model="showUpload"
        :viewed-testator-id="viewedTestatorId"
        :document-type="category.type"
        :document-type-display-name="category.displayName"
        :description="category.description"
        :allow-multiple-files="true"
        @uploaded="onUploaded"
      />

      <EditDocumentDialog
        v-if="showEdit && editingDocument"
        v-model="showEdit"
        :document="editingDocument"
        @saved="onEdited"
      />
    </div>
  </v-card>
</template>

<script>
  import DocumentFileRow from './DocumentFileRow.vue';
  import DocumentIconBadge from './DocumentIconBadge.vue';
  import DocumentBadges from './DocumentBadges.vue';
  import UploadDocumentDialog from './UploadDocumentDialog.vue';
  import EditDocumentDialog from './EditDocumentDialog.vue';
  import DocumentUploadButton from './DocumentUploadButton.vue';
  import FunkButton from '../guest/FunkButton.vue';
  import { documentDeletePermissionMixin } from '../../mixins/document-delete-permission';

  export default {
    name: 'DocumentMultiCard',
    components: {
      DocumentFileRow,
      DocumentIconBadge,
      DocumentBadges,
      UploadDocumentDialog,
      EditDocumentDialog,
      DocumentUploadButton,
      FunkButton,
    },
    mixins: [documentDeletePermissionMixin],
    props: {
      viewedTestatorId: { type: [Number, String], required: true },
      category: { type: Object, required: true },
      documents: { type: Array, default: () => [] },
    },
    data() {
      return {
        showUpload: false,
        showEdit: false,
        editingDocument: null,
      };
    },
    watch: {
      showEdit(open) {
        if (!open) this.editingDocument = null;
      },
    },
    methods: {
      openEdit(document) {
        this.editingDocument = document;
        this.showEdit = true;
      },
      onUploaded() {
        this.$emit('refetch');
      },
      onEdited() {
        this.$emit('refetch');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../constants/styles/people-overview-info-blocks.scss';
  @import '../../constants/styles/document-card.scss';

  .document-instance {
    padding-top: 16px;
    margin-top: 16px;
    border-top: 1px solid #e5e7eb;
  }
  .document-instance:first-child {
    padding-top: 0;
    margin-top: 0;
    border-top: none;
  }
  .document-note-row {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #6b7280;
    margin-top: 8px;
    margin-bottom: 0;
  }
  .document-note-row strong {
    color: #282828;
  }
</style>
